import React from 'react';
import {
  useFormContext,
} from 'react-hook-form';
import TemplateDialog from 'views/EMR/components/VisitNoteTemplateDialog';
import {
  VisitNoteData,
} from 'pages/Dashboard/pages/Encounters/pages/VisitNote/components/MainContent';

type Props = {
  onClose: () => void;
};

export default function NewMasterTemplateDialog({ onClose }: Props) {
  const { watch } = useFormContext<VisitNoteData>();
  const [
    plan,
    physicalExam,
    additionalAssessment,
    additionalHPI,
    radiology,
    billingCodes,
    customServiceCodes,
    assessmentCodes,
  ] = watch([
    'plan',
    'physicalExam',
    'additionalAssessment',
    'additionalHPI',
    'radiology',
    'bill.serviceCodes',
    'bill.customServiceCodes',
    'bill.assessmentCodes',
  ]);

  return (
    <TemplateDialog
      onSelect={null}
      content={{
        billingCodes,
        additionalAssessment,
        additionalHPI,
        radiology,
        plan,
        assessmentCodes,
        customServiceCodes,
        physicalExam,
      }}
      onClose={onClose}
    />
  );
}
